import React from 'react';
import { Button } from 'antd';
import { CloudOutlined } from '@ant-design/icons';

const FreeService = () => {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
            {/* Header */}
            <header style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 50px',
                height: '64px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '20px', fontWeight: 'bold', color: '#1890ff' }}>
                    <CloudOutlined style={{ fontSize: '24px' }} />
                    优量宝
                </div>
                <nav>
                    <ul style={{ display: 'flex', gap: '40px', listStyle: 'none', margin: 0, padding: 0, fontSize: '16px', color: '#666' }}>
                        <li style={{ cursor: 'pointer', color: '#1890ff' }}>首页</li>
                        <li style={{ cursor: 'pointer' }}>我们的优势</li>
                        <li style={{ cursor: 'pointer' }}>下载</li>
                        <li style={{ cursor: 'pointer' }}>联系我们</li>
                    </ul>
                </nav>
            </header>

            {/* Hero Section */}
            <main style={{ flex: 1, position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* Background Decor - Abstract Triangles */}
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0 }}>
                    <div style={{ position: 'absolute', top: '10%', right: '10%', width: '0', height: '0', borderLeft: '50px solid transparent', borderRight: '50px solid transparent', borderBottom: '100px solid rgba(24, 144, 255, 0.1)', transform: 'rotate(15deg)' }}></div>
                    <div style={{ position: 'absolute', bottom: '20%', left: '15%', width: '0', height: '0', borderLeft: '30px solid transparent', borderRight: '30px solid transparent', borderBottom: '60px solid rgba(24, 144, 255, 0.2)', transform: 'rotate(-20deg)' }}></div>
                    <div style={{ position: 'absolute', top: '40%', left: '50%', width: '0', height: '0', borderLeft: '80px solid transparent', borderRight: '80px solid transparent', borderBottom: '160px solid rgba(24, 144, 255, 0.05)', transform: 'rotate(45deg)' }}></div>
                </div>

                <div style={{ zIndex: 1, display: 'flex', width: '100%', maxWidth: '1200px', padding: '0 50px', alignItems: 'center' }}>
                    {/* Left Content */}
                    <div style={{ flex: 1 }}>
                        <h1 style={{
                            fontSize: '120px',
                            fontWeight: '900',
                            color: '#1890ff',
                            lineHeight: '1.2',
                            margin: 0,
                            textShadow: '4px 4px 0px rgba(24,144,255,0.2)'
                        }}>
                            零 <span style={{ fontSize: '60px', color: '#333', fontWeight: 'bold' }}>成本</span>
                        </h1>
                        <div style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px 20px',
                            fontSize: '24px',
                            display: 'inline-block',
                            marginTop: '20px',
                            marginBottom: '10px'
                        }}>
                            优量宝短篇服务免费使用
                        </div>
                        <div style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px 20px',
                            fontSize: '24px',
                            display: 'inline-block'
                        }}>
                            不需要收取任何应用使用费用
                        </div>
                    </div>

                    {/* Right Image/Mockup (using shapes/text to simulate the laptop in the image as per "fake" instruction) */}
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <img src="https://wecom.wzxn.top/pic/one.jpg" alt="Laptop Mockup" style={{ width: '100%', maxWidth: '600px', transform: 'perspective(1000px) rotateY(-10deg)' }} />
                    </div>
                </div>
            </main>

            {/* Footer Decor */}
            <div style={{ height: '100px', background: '#e6f7ff', borderTopLeftRadius: '50% 20%', borderTopRightRadius: '50% 20%' }}></div>
        </div>
    );
};

export default FreeService;
